// Module
var code = "<main-header></main-header> <main-nav data-ref=nav></main-nav> <main id=routing></main> <main-footer></main-footer> ";
// Exports
export default code;